import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconArrowDown: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.99995 10.0546C3.99995 9.85464 4.09995 9.55464 4.19995 9.35464C4.59995 8.95464 5.19995 8.85464 5.59995 9.25464L11.9999 14.7546L18.3 9.25464C18.6999 8.85464 19.4 8.95464 19.7 9.35464C20.1 9.75464 20 10.4546 19.6 10.7546L12.5999 16.7546C12.1999 17.0546 11.7 17.0546 11.3 16.7546L4.29995 10.7546C4.09995 10.6546 3.99995 10.3546 3.99995 10.0546Z',
    })
  )
}
